import React from "react";
import { Navigate } from "react-router-dom";
import { selectisAuthenticated } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";

function ProtectedRoute({ children }) {
  const Auth = useSelector(selectisAuthenticated);

  if (!Auth.isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
